import { useContext, useEffect } from 'react'
import { TrainingCalendarContext } from 'context/TrainingCalendarContext'
import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'

import ContentFrame from 'components/Frame/ContentFrame'

export default function WorkoutScheduleDisplayMode({
    programMetadata = null,
    selectedWeekOfTheYearKey = null,
    trainingCalendarData = null,
    trainingCalendarDateRange = [],
    LoadTrainingCalendarData = () => {}
}) {

    const { UpdateTrainingCalendarDateRange } = useContext(TrainingCalendarContext)

    useEffect(() => {
        if (!selectedWeekOfTheYearKey) return
        UpdateTrainingCalendarDateRange(new WeekOfTheYearKey(selectedWeekOfTheYearKey).toDate().startOf('day'))
    }, [selectedWeekOfTheYearKey, UpdateTrainingCalendarDateRange])

    useEffect(() => { LoadTrainingCalendarData() }, [trainingCalendarDateRange])

    const kinesisScheduledWorkoutDataCalendarItems = (
        trainingCalendarData === null ? [] :
            trainingCalendarData.filter((item) => (
                item.calendarEventType === 'kinesis-scheduled-workout-data'
            ))
    )
    
    if (programMetadata === null) return null

    const workoutPhaseTypeHashMap = programMetadata?.workoutPhaseTypeHashMap ?? {}

    console.log(kinesisScheduledWorkoutDataCalendarItems)

    return (
        <ContentFrame className='flex h-full min-h-0 flex-col'>
            <div className="flex h-full min-h-0 w-full min-w-0 flex-1 flex-col select-none">
                <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white">
                    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
                        <div
                            className="relative grid h-full min-h-0 w-full min-w-0 flex-1 divide-x divide-gray-200"
                            style={{
                                gridTemplateColumns: `repeat(${trainingCalendarDateRange.length}, minmax(0, 1fr))`
                            }}
                        >
                            {trainingCalendarDateRange.map((date, index) => {
                                const dateKey = date.format('YYYY-MM-DD')
                                const scheduledItemsForDate = kinesisScheduledWorkoutDataCalendarItems.filter((item) => item.date === dateKey)

                                return (
                                    <div
                                        key={index}
                                        className="flex h-full min-h-0 min-w-0 flex-col"
                                    >
                                        <div className="relative shrink-0 bg-white px-2 py-2 text-center min-w-0 border-b border-gray-200">
                                            <div className='truncate text-center tracking-wide font-bold text-xs 2xl:text-sm'>
                                                {date.format('dddd')}
                                            </div>
                                        </div>

                                        <div className="shrink-0 text-gray-600 px-1.5 2xl:px-2 pt-1 2xl:pt-1.5 text-xxs 2xl:text-xs">
                                            {date.format('MMM Do')}
                                        </div>

                                        {trainingCalendarData === null &&
                                            <div className="p-2 space-y-2">
                                                {Array.from({ length: 4 }, (_, i) => (
                                                    <div
                                                        key={i}
                                                        className="space-y-2 rounded-lg bg-gray-100 p-2 animate-pulse"
                                                    >
                                                        <div className="h-4" />
                                                    </div>
                                                ))}
                                            </div>
                                        }

                                        {trainingCalendarData !== null &&
                                            <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto p-2 text-xxs 2xl:text-xs">
                                                {scheduledItemsForDate.map((scheduledItem, index) => (
                                                    <div
                                                        key={index}
                                                        className="w-full rounded-md border border-gray-200 bg-white p-1.5 space-y-1 shadow"
                                                    >
                                                        <div className='text-xxs 2xl:text-xs font-medium truncate flex-1'>
                                                            {scheduledItem.workoutConfigName}
                                                        </div>

                                                        {scheduledItem.exerciseBlocks.map((exerciseBlock, index) => (
                                                            <div 
                                                                key={index}
                                                                className='bg-gray-100 p-1 flex items-center'
                                                            >
                                                                <p className='text-xxs flex-1'>
                                                                    {workoutPhaseTypeHashMap[exerciseBlock.workoutPhaseTypeId].name}
                                                                    {' '}
                                                                    {/* Kinda hacky way to display block based on last char of name but it works for now */}
                                                                    {exerciseBlock.exerciseBlockName.slice(-1)} 
                                                                </p>

                                                                <p className='text-xxs font-bold'>
                                                                    {exerciseBlock.exerciseBlockOccurrenceIndex}
                                                                </p>

                                                                {/* <p className='text-xxs truncate flex-1'>
                                                                    {exerciseBlock.exerciseBlockName}
                                                                </p> */}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </ContentFrame>
    )
}
